export const STATUS_COURIER = {
  waiting: {
    label: 'Menunggu Pembayaran',
    color: '#000',
    bg: 'softDanger',
  },
  process: {
    label: 'Diproses',
    color: '#000',
    bg: 'softBlue',
  },
  delivery: {
    label: 'Dikirim',
    color: '#000',
    bg: 'softBlue',
  },
  come: {
    label: 'Barang Sampai',
    color: '#000',
    bg: 'softBlue',
  },
  finish: {
    label: 'Selesai',
    color: '#000',
    bg: 'softGreen',
  },
  cancel: {
    label: 'Dibatalkan',
    color: '#fff',
    bg: 'danger',
  },
  preOrder: {
    label: 'Pre-Order',
    color: '#000',
    bg: 'softBlue',
  },
  available: {
    label: 'Tersedia',
    color: '#000',
    bg: 'softBlue',
  },
  Unavailable: {
    label: 'Tidak Tersedia',
    color: '#FF3B30',
    bg: 'lightDanger',
  },
  waitingConfirmation: {
    label: 'Menunggu Konfirmasi',
    color: '#000',
    bg: 'orange',
  },
};

export type CourierType = keyof typeof STATUS_COURIER;
